import gql from 'graphql-tag';
import { COMMITMENT_TYPE } from './CommitmentType.gql';

export const COMMITMENT_BY_ID_QUERY = gql`
  ${COMMITMENT_TYPE}
  query getCommitmentById($commitmentId: ID!) {
    getCommitmentById(commitmentId: $commitmentId) {
      ...CommitmentType
    }
  }
`;
